import { render, staticRenderFns } from "./clipboard.vue?vue&type=template&id=6570067e&scoped=true"
import script from "./clipboard.vue?vue&type=script&lang=js"
export * from "./clipboard.vue?vue&type=script&lang=js"
import style0 from "./clipboard.vue?vue&type=style&index=0&id=6570067e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6570067e",
  null
  
)

export default component.exports